export default function AmenitiesBadge({ children }){
  return <span className="inline-block text-xs px-2 py-1 mr-2 border rounded-full text-gray-600">{children}</span>;
}
